var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.999 500",
    style: {
      enableBackground: "new 0 0 499.999 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1342_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000128477328424557618150000002838348890995079562_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.0919,
    y1: 178.5682,
    x2: 259.1989,
    y2: 327.3506,
    gradientTransform: "matrix(0.9626 0.2711 -0.2711 0.9626 53.0488 -74.8517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    style: {
      fill: "url(#XMLID_00000128477328424557618150000002838348890995079562_)"
    },
    d: "M236.527,267.921 c0.357-10.473-4.108-21.086-12.847-27.177c-5.201-3.625-13.948-4.699-16.295-11.364c-2.021-5.739,0.644-12.028,0.718-17.896 c0.132-10.374-5.055-20.62-13.397-26.753c-5.676-4.173-13.246-5.574-18.054-10.94c-4.436-4.951-5.878-11.742-7.97-17.865 c-3.013-8.818-10.977-21.001-22.051-16.821c-9.373,3.538-11.071,15.813-10.109,24.42c0.344,3.077,1.01,6.114,1.997,9.049 c1.14,3.389,3.067,6.508,4.019,9.947c1.008,3.644,1.768,7.945,1.206,11.699c-0.508,3.395-1.701,6.662-2.191,10.071 c-1.8,12.531,3.123,25.026,10.46,35.025c4.882,6.653,8.512,12.154,8.706,20.68c0.15,6.623-0.825,13.311,0.532,19.865 c2.675,12.914,13.552,21.697,25.722,25.285c0.334,0.098,0.672,0.036,0.95-0.128 C211.032,308.963,234.747,291.703,236.527,267.921z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000028300487048316505080000001589109256184167093_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.0919,
    y1: 178.5682,
    x2: 259.1989,
    y2: 327.3506,
    gradientTransform: "matrix(0.9626 0.2711 -0.2711 0.9626 53.0488 -74.8517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    style: {
      opacity: 0.4,
      fill: "url(#XMLID_00000028300487048316505080000001589109256184167093_)"
    },
    d: " M236.527,267.921c0.357-10.473-4.108-21.086-12.847-27.177c-5.201-3.625-13.948-4.699-16.295-11.364 c-2.021-5.739,0.644-12.028,0.718-17.896c0.132-10.374-5.055-20.62-13.397-26.753c-5.676-4.173-13.246-5.574-18.054-10.94 c-4.436-4.951-5.878-11.742-7.97-17.865c-3.013-8.818-10.977-21.001-22.051-16.821c-9.373,3.538-11.071,15.813-10.109,24.42 c0.344,3.077,1.01,6.114,1.997,9.049c1.14,3.389,3.067,6.508,4.019,9.947c1.008,3.644,1.768,7.945,1.206,11.699 c-0.508,3.395-1.701,6.662-2.191,10.071c-1.8,12.531,3.123,25.026,10.46,35.025c4.882,6.653,8.512,12.154,8.706,20.68 c0.15,6.623-0.825,13.311,0.532,19.865c2.675,12.914,13.552,21.697,25.722,25.285c0.334,0.098,0.672,0.036,0.95-0.128 C211.032,308.963,234.747,291.703,236.527,267.921z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000159471907627532552090000005595254813177733530_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.5419,
    y1: 326.4792,
    x2: 207.5419,
    y2: 202.0048,
    gradientTransform: "matrix(0.9626 0.2711 -0.2711 0.9626 53.0488 -74.8517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    style: {
      fill: "url(#XMLID_00000159471907627532552090000005595254813177733530_)"
    },
    d: "M215.123,316.398 c-5.093-12.473-10.167-24.952-15.231-37.436c0.006-0.015,0.015-0.027,0.021-0.042c4.385-11.415,7.096-23.277,8.163-35.455 c0.139-1.588-2.342-1.598-2.48-0.014c-0.965,11.008-3.36,21.731-7.088,32.105c-4.288-10.578-8.558-21.163-12.826-31.749 c0.07-0.095,0.134-0.199,0.181-0.324c4.468-11.801,7.411-24.016,8.871-36.548c0.184-1.581-2.297-1.587-2.48-0.014 c-1.338,11.478-4.015,22.678-7.926,33.534c-3.997-9.921-7.979-19.848-11.958-29.776c2.676-8.458,4.662-17.072,5.951-25.851 c0.229-1.557-2.155-2.249-2.387-0.672c-1.137,7.746-2.816,15.364-5.033,22.86c-3.961-9.889-7.911-19.783-11.854-29.68 c0.105-0.119,0.193-0.263,0.254-0.439c1.893-5.48,3.533-11.027,4.924-16.655c0.382-1.546-2.003-2.225-2.387-0.672 c-1.196,4.839-2.588,9.615-4.155,14.344c-2.64-6.631-5.289-13.258-7.921-19.892c-0.581-1.464-2.989-0.86-2.4,0.624 c3.635,9.162,7.289,18.316,10.94,27.471c-4.094-3.312-8.284-6.499-12.598-9.531c-1.308-0.919-2.582,1.21-1.283,2.123 c5.432,3.818,10.679,7.865,15.762,12.133c3.216,8.06,6.442,16.116,9.67,24.171c0.024,0.091,0.057,0.176,0.102,0.255 c1.805,4.504,3.61,9.009,5.419,13.511c-9.719-4.93-18.811-10.885-27.191-17.886c-1.22-1.02-2.946,0.762-1.72,1.787 c9.283,7.756,19.407,14.31,30.303,19.569c4.614,11.478,9.243,22.95,13.881,34.418c-7.782-3.732-15.563-7.463-23.345-11.194 c-1.428-0.685-2.721,1.433-1.283,2.123c8.667,4.156,17.333,8.312,26,12.467c6.957,17.192,13.931,34.378,20.942,51.548 C213.563,319.086,215.72,317.859,215.123,316.398z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000108275158352190652740000005576858676374923436_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.8394,
    y1: 190.2254,
    x2: 214.7592,
    y2: 361.9344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    style: {
      fill: "url(#XMLID_00000108275158352190652740000005576858676374923436_)"
    },
    d: "M226.667,307.501 c-2.88-11.745-11.16-22.137-22.773-26.169c-6.911-2.4-16.964-0.856-21.656-7.526c-4.04-5.743-3.048-13.562-4.801-20.104 c-3.099-11.565-12.066-21.324-23.252-25.526c-7.611-2.859-16.458-2.048-23.477-6.505c-6.477-4.112-10.203-11.205-14.442-17.351 c-6.106-8.853-18.764-19.894-29.757-11.787c-9.305,6.862-7.351,21.03-3.59,30.29c1.345,3.311,3.035,6.476,5.049,9.427 c2.327,3.408,5.443,6.269,7.576,9.792c2.26,3.733,4.449,8.272,4.999,12.618c0.498,3.93,0.195,7.933,0.717,11.873 c1.921,14.483,11.298,26.822,22.576,35.634c7.504,5.863,13.257,10.838,16.14,20.249c2.239,7.31,3.248,15.044,6.806,21.9 c7.011,13.508,21.841,19.861,36.483,20.041c0.401,0.005,0.758-0.171,1.015-0.44 C211.186,361.068,232.129,334.476,226.667,307.501z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000098203257628962755100000001157519863891646653_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1367,
    y1: 360.9286,
    x2: 154.1367,
    y2: 217.2734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    style: {
      fill: "url(#XMLID_00000098203257628962755100000001157519863891646653_)"
    },
    d: "M216.374,365.884 c-8.995-11.543-17.978-23.095-26.949-34.657c0.002-0.018,0.008-0.034,0.01-0.053c1.3-14.052,0.601-28.077-2.024-41.938 c-0.342-1.807-3.101-1.042-2.76,0.761c2.373,12.53,3.066,25.191,2.17,37.881c-8.073-10.409-16.127-20.831-24.18-31.255 c0.048-0.128,0.087-0.263,0.1-0.417c1.272-14.507,0.719-28.996-1.579-43.374c-0.29-1.814-3.048-1.044-2.76,0.761 c2.105,13.169,2.634,26.448,1.686,39.73c-7.544-9.77-15.072-19.551-22.598-29.335c0.327-10.232-0.163-20.423-1.477-30.577 c-0.233-1.801-3.098-1.824-2.862,0c1.16,8.96,1.679,17.948,1.561,26.968c-7.494-9.746-14.977-19.5-22.453-29.26 c0.079-0.165,0.132-0.352,0.145-0.568c0.388-6.679,0.475-13.355,0.259-20.042c-0.059-1.837-2.921-1.845-2.862,0 c0.185,5.75,0.133,11.491-0.128,17.233c-5.007-6.54-10.023-13.073-15.022-19.618c-1.103-1.444-3.59-0.02-2.471,1.444 c6.904,9.04,13.827,18.065,20.746,27.094c-5.584-2.398-11.235-4.628-16.976-6.646c-1.741-0.612-2.49,2.152-0.761,2.76 c7.228,2.542,14.323,5.396,21.304,8.546c6.094,7.947,12.198,15.886,18.304,23.824c0.055,0.094,0.118,0.178,0.193,0.251 c3.415,4.439,6.829,8.878,10.247,13.313c-12.339-2.436-24.301-6.206-35.8-11.362c-1.675-0.751-3.034,1.769-1.352,2.523 c12.738,5.711,26.035,9.824,39.783,12.257c8.716,11.307,17.447,22.602,26.187,33.89c-9.811-1.711-19.623-3.421-29.434-5.132 c-1.801-0.314-2.575,2.443-0.761,2.76c10.927,1.905,21.854,3.81,32.781,5.715c12.024,15.524,24.069,31.032,36.137,46.523 H216.374z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    style: {
      fill: "#f54a4a"
    },
    d: "M359.531,199.305c0,9.99-8.098,18.088-18.088,18.088 c9.99,0,18.088,8.098,18.088,18.088c0-9.99,8.098-18.088,18.088-18.088C367.629,217.393,359.531,209.294,359.531,199.305z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    style: {
      fill: "#f54a4a"
    },
    d: "M337.005,199.305c0,4.216-3.417,7.633-7.633,7.633 c4.216,0,7.633,3.417,7.633,7.633c0-4.216,3.418-7.633,7.633-7.633C340.423,206.938,337.005,203.52,337.005,199.305z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_11_",
    x: 224.96,
    y: 247.927,
    style: {
      fill: "#4f46e5"
    },
    width: 15.928,
    height: 30.244
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_16_",
    x: 268.821,
    y: 247.927,
    style: {
      fill: "#4f46e5"
    },
    width: 15.928,
    height: 30.244
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000178166596099115181930000002784224688190106540_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9242,
    y1: 279.612,
    x2: 232.9242,
    y2: 232.3394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f46e5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_55_",
    x: 224.96,
    y: 247.927,
    style: {
      fill: "url(#XMLID_00000178166596099115181930000002784224688190106540_)"
    },
    width: 15.928,
    height: 30.244
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000154419474998076464540000014782003558978059197_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.785,
    y1: 279.612,
    x2: 276.785,
    y2: 232.3394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f46e5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: 268.821,
    y: 247.927,
    style: {
      fill: "url(#XMLID_00000154419474998076464540000014782003558978059197_)"
    },
    width: 15.928,
    height: 30.244
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    style: {
      fill: "#4f46e5"
    },
    d: "M284.749,267.754H224.96l-49.896,56.277c-1.408,1.588-2.185,3.637-2.185,5.759 v28.817c0,4.794,3.887,8.681,8.681,8.681h146.589c4.794,0,8.681-3.887,8.681-8.681V329.79c0-2.122-0.777-4.171-2.185-5.759 L284.749,267.754z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000061447685305256102000000007049922665331843984_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8547,
    y1: 309.7054,
    x2: 254.8547,
    y2: 406.9366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f46e5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    style: {
      opacity: 0.5,
      fill: "url(#XMLID_00000061447685305256102000000007049922665331843984_)"
    },
    d: " M284.749,267.754H224.96l-49.896,56.277c-1.408,1.588-2.185,3.637-2.185,5.759v28.817c0,4.794,3.887,8.681,8.681,8.681h146.589 c4.794,0,8.681-3.887,8.681-8.681V329.79c0-2.122-0.777-4.171-2.185-5.759L284.749,267.754z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    style: {
      fill: "#4f46e5"
    },
    d: "M298.808,229.264h-88.128h-28.405c-7.671,0-13.889,6.218-13.889,13.889v9.549 v13.889h42.294v-13.889h88.128v13.889h42.294v-13.889v-9.549c0-7.671-6.218-13.889-13.889-13.889H298.808z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#4f46e5"
    },
    d: "M213.027,256.608h-47.304c-0.599,0-1.085,0.486-1.085,1.085v13.455 c0,0.599,0.486,1.085,1.085,1.085h47.304c0.599,0,1.085-0.486,1.085-1.085v-13.455 C214.112,257.094,213.626,256.608,213.027,256.608z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    style: {
      fill: "#4f46e5"
    },
    d: "M343.986,256.608h-47.304c-0.599,0-1.085,0.486-1.085,1.085v13.455 c0,0.599,0.486,1.085,1.085,1.085h47.304c0.599,0,1.085-0.486,1.085-1.085v-13.455 C345.071,257.094,344.586,256.608,343.986,256.608z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    style: {
      opacity: 0.4,
      fill: "#4f46e5"
    },
    d: "M213.027,256.608h-47.304c-0.599,0-1.085,0.486-1.085,1.085v13.455 c0,0.599,0.486,1.085,1.085,1.085h47.304c0.599,0,1.085-0.486,1.085-1.085v-13.455 C214.112,257.094,213.626,256.608,213.027,256.608z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    style: {
      opacity: 0.4,
      fill: "#4f46e5"
    },
    d: "M343.986,256.608h-47.304c-0.599,0-1.085,0.486-1.085,1.085v13.455 c0,0.599,0.486,1.085,1.085,1.085h47.304c0.599,0,1.085-0.486,1.085-1.085v-13.455 C345.071,257.094,344.586,256.608,343.986,256.608z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    style: {
      opacity: 0.5,
      fill: "#4f46e5"
    },
    d: "M235.535,305.66c-11.023,10.67-11.31,28.256-0.64,39.279 s28.256,11.31,39.279,0.64c11.023-10.67,11.31-28.256,0.64-39.279C264.144,295.277,246.558,294.99,235.535,305.66z  M264.972,336.072c-5.773,5.588-14.982,5.438-20.57-0.335c-5.588-5.773-5.438-14.982,0.335-20.57 c5.773-5.588,14.982-5.438,20.57,0.335C270.895,321.275,270.745,330.485,264.972,336.072z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#3b82f6"
    },
    d: "M235.535,303.924c-11.023,10.67-11.31,28.256-0.64,39.279 c10.67,11.023,28.256,11.31,39.279,0.64c11.023-10.67,11.31-28.256,0.64-39.279 C264.144,293.541,246.558,293.254,235.535,303.924z M264.972,334.336c-5.773,5.588-14.982,5.438-20.57-0.335 c-5.588-5.773-5.438-14.982,0.335-20.57c5.773-5.588,14.982-5.438,20.57,0.335C270.895,319.539,270.745,328.749,264.972,334.336 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    style: {
      fill: "#4f46e5"
    },
    d: "M266.134,342.121c-1.621-1.674-1.577-4.345,0.097-5.966s4.345-1.577,5.966,0.097 c1.621,1.674,1.577,4.345-0.097,5.966C270.426,343.839,267.755,343.796,266.134,342.121z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    style: {
      fill: "#4f46e5"
    },
    d: "M251.414,345.043c-0.137-2.326,1.638-4.323,3.964-4.46 c2.326-0.137,4.323,1.638,4.46,3.964c0.137,2.326-1.638,4.323-3.964,4.46C253.548,349.144,251.551,347.369,251.414,345.043z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    style: {
      fill: "#4f46e5"
    },
    d: "M238.515,337.639c1.413-1.853,4.061-2.209,5.913-0.796 c1.853,1.413,2.209,4.06,0.796,5.913c-1.413,1.853-4.061,2.209-5.913,0.796C237.458,342.139,237.102,339.491,238.515,337.639z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    style: {
      fill: "#4f46e5"
    },
    d: "M233.13,323.639c2.279-0.483,4.519,0.973,5.002,3.252 c0.483,2.279-0.973,4.519-3.252,5.002c-2.279,0.483-4.519-0.973-5.002-3.252C229.395,326.361,230.851,324.122,233.13,323.639z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    style: {
      fill: "#4f46e5"
    },
    d: "M238.178,309.514c2.043,1.12,2.791,3.684,1.671,5.728 c-1.12,2.043-3.684,2.792-5.728,1.671c-2.043-1.12-2.792-3.684-1.671-5.728C233.57,309.142,236.134,308.393,238.178,309.514z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    style: {
      fill: "#4f46e5"
    },
    d: "M251.215,302.096c0.819,2.182-0.286,4.614-2.468,5.432 c-2.181,0.819-4.614-0.286-5.432-2.468c-0.819-2.181,0.286-4.614,2.468-5.432C247.964,298.81,250.396,299.914,251.215,302.096z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    style: {
      fill: "#4f46e5"
    },
    d: "M265.936,304.974c-0.802,2.188-3.226,3.311-5.413,2.509 c-2.188-0.802-3.311-3.225-2.509-5.413c0.802-2.188,3.225-3.311,5.413-2.509C265.614,300.362,266.738,302.786,265.936,304.974z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    style: {
      fill: "#4f46e5"
    },
    d: "M274.956,316.482c-2.035,1.136-4.605,0.407-5.74-1.628 c-1.136-2.035-0.407-4.605,1.628-5.74c2.035-1.136,4.605-0.407,5.74,1.628C277.719,312.776,276.99,315.346,274.956,316.482z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    style: {
      fill: "#4f46e5"
    },
    d: "M274.873,330.019c-2.283-0.466-3.756-2.694-3.291-4.977 c0.466-2.283,2.694-3.756,4.977-3.291c2.283,0.466,3.756,2.694,3.291,4.977C279.384,329.012,277.156,330.485,274.873,330.019z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    style: {
      fill: "#4f46e5"
    },
    d: "M279.008,337.615l-11.07-7.365l12.496,4.483 C280.434,334.733,279.557,336.691,279.008,337.615z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    style: {
      opacity: 0.4,
      fill: "#4f46e5"
    },
    d: "M279.008,337.615l-11.07-7.365l12.496,4.483 C280.434,334.733,279.557,336.691,279.008,337.615z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_69_",
    style: {
      fill: "#3b82f6"
    },
    points: "91.023,322.529 126.987,289.677 162.951,322.529 162.951,352.552  91.023,352.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_68_",
    style: {
      opacity: 0.5,
      fill: "#3b82f6"
    },
    points: "91.023,322.529 126.987,289.677 162.951,322.529  162.951,352.552 91.023,352.552  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_71_",
    style: {
      fill: "#3b82f6"
    },
    points: "92.367,272.51 148.334,272.51 160.122,284.299 160.122,352.061  92.367,352.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_72_",
    style: {
      opacity: 0.4,
      fill: "#F9F9F9"
    },
    points: "92.367,272.51 148.334,272.51 160.122,284.299  160.122,352.061 92.367,352.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_77_",
    style: {
      fill: "#3b82f6"
    },
    points: "148.334,284.299 160.122,284.299 148.334,272.51  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    style: {
      fill: "#3b82f6"
    },
    d: "M141.494,308.099c0,5.705-2.614,8.957-6.534,8.957 c-2.167,0-3.697-0.957-4.366-2.773c-1.116,1.785-2.933,2.773-5.45,2.773c-4.112,0-7.363-3.252-7.363-8.064 c0-4.781,3.219-8.032,7.363-8.032c2.104,0,3.761,0.733,4.909,2.104v-1.88h4.335v10.327c0,1.53,0.669,2.04,1.53,2.04 c1.466,0,2.359-1.689,2.359-5.386c0-6.47-4.781-10.932-11.857-10.932c-7.108,0-11.857,4.845-11.857,11.506 c0,6.789,4.654,11.602,11.729,11.602c2.008,0,4.271-0.414,6.279-1.402l1.02,2.932c-1.944,0.988-4.781,1.53-7.299,1.53 c-9.211,0-15.299-6.247-15.299-14.661c0-8.319,6.152-14.534,15.427-14.534C135.374,294.203,141.494,300.099,141.494,308.099z  M130.115,308.992c0-2.773-1.689-4.335-3.984-4.335c-2.327,0-3.952,1.625-3.952,4.335c0,2.741,1.625,4.399,3.952,4.399 C128.426,313.391,130.115,311.797,130.115,308.992z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_70_",
    style: {
      fill: "#3b82f6"
    },
    points: "162.951,365.524 91.023,365.524 91.023,322.529 126.987,343.145  162.951,322.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_66_",
    style: {
      fill: "#3b82f6"
    },
    points: "162.951,367.288 91.023,367.288 91.023,322.529 126.987,344.908  162.951,322.529  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    style: {
      fill: "#3b82f6"
    },
    d: "M159.714,365.177c0,0-1.544-1.037-3.747-2.725 c-1.106-0.839-2.377-1.839-3.72-2.933c-0.668-0.551-1.37-1.107-2.061-1.698c-0.694-0.587-1.399-1.184-2.104-1.78 c-0.695-0.608-1.391-1.216-2.075-1.814c-0.689-0.593-1.342-1.206-1.987-1.783c-1.283-1.164-2.462-2.272-3.456-3.24 c-1.998-1.926-3.253-3.299-3.253-3.299s1.545,1.036,3.748,2.724c1.106,0.839,2.377,1.839,3.72,2.933 c0.667,0.552,1.371,1.106,2.06,1.698c0.694,0.587,1.399,1.184,2.104,1.78c0.695,0.608,1.39,1.216,2.074,1.815 c0.687,0.595,1.341,1.207,1.986,1.784c1.282,1.165,2.461,2.272,3.456,3.24C158.458,363.805,159.714,365.177,159.714,365.177z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    style: {
      fill: "#3b82f6"
    },
    d: "M94.26,365.177c0,0,1.256-1.372,3.254-3.298 c0.995-0.968,2.174-2.075,3.456-3.24c0.645-0.578,1.299-1.189,1.986-1.784c0.684-0.599,1.379-1.207,2.074-1.815 c0.705-0.597,1.41-1.193,2.104-1.78c0.689-0.593,1.393-1.147,2.06-1.698c1.343-1.094,2.614-2.094,3.72-2.933 c2.203-1.688,3.748-2.724,3.748-2.724s-1.255,1.373-3.253,3.299c-0.994,0.968-2.173,2.076-3.456,3.24 c-0.645,0.577-1.298,1.19-1.987,1.783c-0.684,0.599-1.38,1.206-2.075,1.814c-0.705,0.596-1.41,1.193-2.104,1.78 c-0.691,0.591-1.393,1.146-2.061,1.698c-1.343,1.094-2.614,2.094-3.72,2.933C95.805,364.141,94.26,365.177,94.26,365.177z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    style: {
      fill: "#3b82f6"
    },
    d: "M317.648,126.083c-24.824-16.324-92.628-18.394-104.452,18.832 c-11.825,37.226,0,52.993,10.511,56.496c7.505,2.502,29.821,5.967,53.237,5.779c2.277,5.531,0.083,13.065,0.083,13.065 c5.693-2.497,9.004-9.395,10.505-13.413c1.655-0.098,3.306-0.216,4.947-0.359c12.215-1.352,34.248-6.839,40.603-22.591 C340.197,166.259,339.315,140.331,317.648,126.083z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_92_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_86_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.0367 261.2305)",
    style: {
      fill: "#3b82f6"
    },
    cx: 301.315,
    cy: 164.458,
    rx: 7.743,
    ry: 7.743
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_93_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -36.428 240.9719)",
    style: {
      fill: "#3b82f6"
    },
    cx: 272.665,
    cy: 164.458,
    rx: 7.743,
    ry: 7.743
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_94_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -44.8194 220.7133)",
    style: {
      fill: "#3b82f6"
    },
    cx: 244.015,
    cy: 164.458,
    rx: 7.743,
    ry: 7.743
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_109_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_100_",
    style: {
      fill: "#3b82f6"
    },
    cx: 405.103,
    cy: 249.481,
    r: 20.217
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_103_",
    x: 401.75,
    y: 243.922,
    style: {
      fill: "#3b82f6"
    },
    width: 6.705,
    height: 18.692
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_106_",
    x: 401.75,
    y: 236.347,
    style: {
      fill: "#3b82f6"
    },
    width: 6.705,
    height: 5.732
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_249_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000005248301572010836000000011933642432118404271_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.1089,
    y1: 323.5559,
    x2: 361.577,
    y2: 323.5559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    style: {
      fill: "url(#XMLID_00000005248301572010836000000011933642432118404271_)"
    },
    d: "M361.246,339.254 c-1.744-4.759-6.019-8.066-10.193-10.941c-4.174-2.875-8.623-5.768-11.068-10.208c-1.594-2.893-2.203-6.317-1.707-9.582 c0.07-0.462,0.172-0.943,0.476-1.297c0.232-0.271,0.56-0.441,0.888-0.582c3.481-1.492,7.676-0.262,10.555,2.198 c2.879,2.461,4.663,5.951,6.099,9.456c2.973,7.256,4.764,14.994,5.281,22.818"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000108991144254455771600000008797046087571444617_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.9839,
    y1: 323.3441,
    x2: 361.7018,
    y2: 323.3441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    style: {
      fill: "url(#XMLID_00000108991144254455771600000008797046087571444617_)"
    },
    d: "M361.924,339.067 c-4.521-11.091-20.105-13.689-22.364-25.782c-0.361-1.934-0.456-4.858,1.717-5.986c1.846-0.958,5.716,0.468,7.304,1.499 c3.459,2.246,5.431,6.224,7.02,9.893c3.105,7.173,4.229,14.72,5.086,22.425c0.124,1.112,1.835,1.168,1.781,0 c-0.42-9.08-2.979-18.86-7.141-26.952c-2.698-5.246-9.464-11.787-15.987-8.614c-5.387,2.621-1.268,12.345,1.333,15.63 c5.698,7.197,15.993,9.682,19.966,18.429C360.964,340.326,362.225,339.807,361.924,339.067L361.924,339.067z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000181080109778640766130000015517289249393190065_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.4692,
    y1: 323.5558,
    x2: 397.924,
    y2: 323.5558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    style: {
      fill: "url(#XMLID_00000181080109778640766130000015517289249393190065_)"
    },
    d: "M369.469,345.291 c1.22-11.795,4.664-23.356,10.099-33.895c2.636-5.111,6.433-10.468,12.118-11.336c1.39-0.212,2.892-0.109,4.073,0.654 c1.57,1.015,2.266,3.032,2.153,4.898c-0.113,1.866-0.906,3.62-1.77,5.278c-3.031,5.816-7.111,11.083-11.983,15.472 c-2.687,2.421-5.622,4.585-8.035,7.28c-3.37,3.764-5.623,8.516-6.405,13.507"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000141429728816941142570000009837245300329240471_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.3449,
    y1: 323.5122,
    x2: 398.049,
    y2: 323.5122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    style: {
      fill: "url(#XMLID_00000141429728816941142570000009837245300329240471_)"
    },
    d: "M370.196,345.291 c1.23-9.772,3.99-19.546,7.964-28.559c1.491-3.381,3.049-6.895,5.256-9.888c1.811-2.457,4.125-4.719,7.12-5.636 c3.634-1.435,5.856,0.446,6.665,5.642c-0.351,1.065-0.793,2.088-1.328,3.069c-3.951,7.959-9.885,13.655-16.556,19.259 c-5.609,4.711-9.399,10.391-10.469,17.731c-0.163,1.116,1.475,1.64,1.74,0.48c1.491-6.513,4.614-11.644,9.497-16.166 c4.022-3.724,8.076-7.297,11.413-11.678c2.996-3.933,11.988-16.656,3.364-20.031c-7.472-2.924-13.814,6.906-16.565,12.168 c-5.501,10.524-8.38,21.85-9.556,33.609C368.649,346.229,370.081,346.2,370.196,345.291L370.196,345.291z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000176722702546341025460000002299863674655815605_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.2896,
    y1: 302.3845,
    x2: 374.3763,
    y2: 302.3845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_291_",
    style: {
      fill: "url(#XMLID_00000176722702546341025460000002299863674655815605_)"
    },
    d: "M367.621,254.811 c-4.712-0.188-6.932,6.497-8.146,10.06c-2.647,7.77-2.938,16.218-2.647,24.346c0.667,18.681,3.178,37.428,7.315,55.629 c0.125,0.552,0.513,0.772,0.92,0.765c0.025,1.177,0.066,2.352,0.147,3.523c0.063,0.905,1.414,1.194,1.654,0.224 c4.541-18.353,6.632-38.229,8.25-57.07C375.671,285.77,379.934,255.303,367.621,254.811z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000047056540100738690320000012939768580813928628_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.2896,
    y1: 302.3845,
    x2: 374.3763,
    y2: 302.3845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_247_",
    style: {
      fill: "url(#XMLID_00000047056540100738690320000012939768580813928628_)"
    },
    d: "M367.621,254.811 c-4.712-0.188-6.932,6.497-8.146,10.06c-2.647,7.77-2.938,16.218-2.647,24.346c0.667,18.681,3.178,37.428,7.315,55.629 c0.125,0.552,0.513,0.772,0.92,0.765c0.025,1.177,0.066,2.352,0.147,3.523c0.063,0.905,1.414,1.194,1.654,0.224 c4.541-18.353,6.632-38.229,8.25-57.07C375.671,285.77,379.934,255.303,367.621,254.811z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_304_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000155124478573363590230000015502735468700344216_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.1137,
    y1: 326.3246,
    x2: 362.7865,
    y2: 326.3246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_354_",
    style: {
      fill: "url(#XMLID_00000155124478573363590230000015502735468700344216_)"
    },
    d: "M363.146,341.448 c-1.976-12.181-8.517-23.583-18.72-30.723c-0.492-0.345-1.117,0.452-0.648,0.84c9.627,7.961,16.089,17.74,18.506,30.121 C362.396,342.255,363.237,342.007,363.146,341.448L363.146,341.448z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_307_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000158728507097243674410000000373724597661372075_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.2947,
    y1: 326.6472,
    x2: 390.5111,
    y2: 326.6472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    style: {
      fill: "url(#XMLID_00000158728507097243674410000000373724597661372075_)"
    },
    d: "M368.969,345.522 c5.049-13.826,13.208-25.815,21.82-37.596c0.259-0.355-0.312-0.787-0.606-0.468c-10.064,10.926-16.722,24.171-22.428,37.729 C367.446,345.921,368.689,346.29,368.969,345.522L368.969,345.522z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_132_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000082338474581308153200000013550737744088081836_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.1894,
    y1: 347.0712,
    x2: 366.1894,
    y2: 265.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c42c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f54a4a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    style: {
      fill: "url(#XMLID_00000082338474581308153200000013550737744088081836_)"
    },
    d: "M367.327,344.741 c0.132-12.916-0.165-25.836-0.257-38.752c-0.091-12.794,1.007-26,0.009-38.738c-0.045-0.569-0.978-0.799-1.077-0.146 c-1.852,12.18-0.892,25.224-0.754,37.523c0.15,13.371,0.348,26.743,0.563,40.113 C365.827,345.716,367.317,345.718,367.327,344.741L367.327,344.741z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_244_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_121_",
    style: {
      fill: "#4f46e5"
    },
    points: "382.253,367.288 353.895,367.288 352.451,341.818 383.697,341.818  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_243_",
    x: 349.843,
    y: 337.805,
    style: {
      fill: "#4f46e5"
    },
    width: 36.462,
    height: 8.785
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_108_",
    x: 349.843,
    y: 337.805,
    style: {
      opacity: 0.5,
      fill: "#4f46e5"
    },
    width: 36.462,
    height: 8.785
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.f219499571035246f21578f19b5cd995.svg";
export { ForwardRef as ReactComponent };